import MaterialIcon from '@/components/atom/MaterialIcon';
import CardRegisterTemplate from '@/components/templates/card/register/CardRegisterTemplate';
import 'react-spring-bottom-sheet/dist/style.css';
import { Drawer } from 'vaul';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSuccessCardRegister: () => void;
}

const CardRegisterBottomSheet = ({ isOpen, onClose, onSuccessCardRegister }: Props) => {
  return (
    <Drawer.Root open={isOpen} dismissible={false}>
      <Drawer.Title />
      <Drawer.Portal>
        <Drawer.Content
          className={
            'fixed right-0 bottom-0 left-0 z-[261] mx-auto h-full w-full bg-white transition-opacity duration-500'
          }
        >
          <div className={'absolute top-0 left-0 z-[261] flex w-full justify-end p-[14px_16px]'} onClick={onClose}>
            <span className={'p-[4px]'}>
              <MaterialIcon name='close' />
            </span>
          </div>
          <div className={'h-full overflow-y-auto'}>
            <CardRegisterTemplate isWebTelemedicineFlow onSuccess={onSuccessCardRegister} />
          </div>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
};

export default CardRegisterBottomSheet;
